"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketsSDK = void 0;
const axios_1 = require("axios");
const queue_1 = require("./services/queue");
const tickets_1 = require("./services/tickets");
const admin_1 = require("./services/admin");
const tables_1 = require("./services/tables");
class TicketsSDK {
    constructor(url) {
        this.url = url;
        this.axiosInstance = axios_1.default.create({
            baseURL: url,
            headers: {
                Headers: 'application/json',
            },
        });
        this.updateControllers(this.axiosInstance);
    }
    updateControllers(config) {
        this.queueService = new queue_1.QueueService(this.axiosInstance);
        this.ticketService = new tickets_1.TicketService(this.axiosInstance);
        this.tableService = new tables_1.TableService(this.axiosInstance);
        this.adminService = new admin_1.AdminService(this.axiosInstance);
    }
    get Queue() {
        return this.queueService;
    }
    get Tickets() {
        return this.ticketService;
    }
    get Admin() {
        return this.adminService;
    }
    get Table() {
        return this.tableService;
    }
}
exports.TicketsSDK = TicketsSDK;
//# sourceMappingURL=index.js.map